import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  RouterStateSnapshot
} from '@angular/router';
import { RedirectService } from '@core/services/core/redirect.service';
import { NavController } from '@ionic/angular';
import { AuthService } from '../core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivateChild {

  constructor(
    private auth: AuthService,
    private nav: NavController,
    private redirectService: RedirectService
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.getState().isLogged) {
      return this.redirectService.getRedirectUrl()
        ? this.redirectService.redirectTo()
        : true;
    } else {
      this.redirectService.setRedirectUrl(state.url);
      this.nav.navigateRoot(['/login'], { animationDirection: 'back' });
      return false;
    }
  }
}
